import { render, staticRenderFns } from "./createProductService.vue?vue&type=template&id=b5e67432&scoped=true"
import script from "./createProductService.vue?vue&type=script&lang=js"
export * from "./createProductService.vue?vue&type=script&lang=js"
import style0 from "./createProductService.vue?vue&type=style&index=0&id=b5e67432&prod&lang=css"
import style1 from "./createProductService.vue?vue&type=style&index=1&id=b5e67432&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e67432",
  null
  
)

export default component.exports